/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pixi = __webpack_require__(2);
	
	var _pixi2 = _interopRequireDefault(_pixi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timer = (function (_PIXI$utils$EventEmit) {
	  _inherits(Timer, _PIXI$utils$EventEmit);
	
	  function Timer() {
	    var time = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	    var manager = arguments[1];
	
	    _classCallCheck(this, Timer);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timer).call(this));
	
	    _this.time = time;
	    if (manager) _this.addTo(manager);
	
	    _this.active = false;
	    _this.isEnded = false;
	    _this.isStarted = false;
	    _this.expire = false;
	    _this.delay = 0;
	    _this.repeat = 0;
	    _this.loop = false;
	
	    _this._delayTime = 0;
	    _this._elapsedTime = 0;
	    _this._repeat = 0;
	    return _this;
	  }
	
	  _createClass(Timer, [{
	    key: 'addTo',
	    value: function addTo(manager) {
	      this.manager = manager;
	      this.manager.addTimer(this);
	      return this;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (!this.manager) return;
	      this.manager.removeTimer(this);
	      return this;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.active = true;
	      return this;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.active = false;
	      this.emit('stop', this._elapsedTime);
	      return this;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this._elapsedTime = 0;
	      this._repeat = 0;
	      this._delayTime = 0;
	      this.isStarted = false;
	      this.isEnded = false;
	      return this;
	    }
	  }, {
	    key: 'update',
	    value: function update(delta, deltaMS) {
	      if (!this.active) return;
	      if (this.delay > this._delayTime) {
	        this._delayTime += deltaMS;
	        return;
	      }
	
	      if (!this.isStarted) {
	        this.isStarted = true;
	        this.emit('start', this._elapsedTime);
	      }
	
	      if (this.time > this._elapsedTime) {
	        var t = this._elapsedTime + deltaMS;
	        var ended = t >= this.time;
	
	        this._elapsedTime = ended ? this.time : t;
	        this.emit('update', this._elapsedTime, delta);
	
	        if (ended) {
	          if (this.loop || this.repeat > this._repeat) {
	            this._repeat++;
	            this.emit('repeat', this._elapsedTime, this._repeat);
	            this._elapsedTime = 0;
	            return;
	          }
	
	          this.isEnded = true;
	          this.active = false;
	          this.emit('end', this._elapsedTime);
	        }
	      }
	    }
	  }]);
	
	  return Timer;
	})(_pixi2.default.utils.EventEmitter);
	
	exports.default = Timer;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = PIXI;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Timer = __webpack_require__(1);
	
	var _Timer2 = _interopRequireDefault(_Timer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TimerManager = (function () {
	  function TimerManager() {
	    _classCallCheck(this, TimerManager);
	
	    this.timers = [];
	    this._timersToDelete = [];
	
	    this._last = 0;
	  }
	
	  _createClass(TimerManager, [{
	    key: 'update',
	    value: function update(delta) {
	      var deltaMS = undefined;
	      if (!delta && delta !== 0) {
	        deltaMS = this._getDeltaMS();
	        delta = deltaMS / 1000;
	      } else {
	        deltaMS = delta * 1000;
	      }
	
	      for (var i = 0; i < this.timers.length; i++) {
	        var timer = this.timers[i];
	        if (timer.active) {
	          timer.update(delta, deltaMS);
	          if (timer.isEnded && timer.expire) {
	            timer.remove();
	          }
	        }
	      }
	
	      if (this._timersToDelete.length) {
	        for (var i = 0; i < this._timersToDelete.length; i++) {
	          this._remove(this._timersToDelete[i]);
	        }
	        this._timersToDelete.length = 0;
	      }
	    }
	  }, {
	    key: 'removeTimer',
	    value: function removeTimer(timer) {
	      this._timersToDelete.push(timer);
	    }
	  }, {
	    key: 'addTimer',
	    value: function addTimer(timer) {
	      timer.manager = this;
	      this.timers.push(timer);
	    }
	  }, {
	    key: 'createTimer',
	    value: function createTimer(time) {
	      return new _Timer2.default(time, this);
	    }
	  }, {
	    key: '_remove',
	    value: function _remove(timer) {
	      var index = this.timers.indexOf(timer);
	      if (index > 0) this.timers.splice(index, 1);
	    }
	  }, {
	    key: '_getDeltaMS',
	    value: function _getDeltaMS() {
	      if (this._last === 0) this._last = Date.now();
	      var now = Date.now();
	      var deltaMS = now - this._last;
	      this._last = now;
	      return deltaMS;
	    }
	  }]);
	
	  return TimerManager;
	})();
	
	exports.default = TimerManager;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pixi = __webpack_require__(2);
	
	var _pixi2 = _interopRequireDefault(_pixi);
	
	var _TimerManager = __webpack_require__(3);
	
	var _TimerManager2 = _interopRequireDefault(_TimerManager);
	
	var _Timer = __webpack_require__(1);
	
	var _Timer2 = _interopRequireDefault(_Timer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timer = {
	  TimerManager: _TimerManager2.default,
	  Timer: _Timer2.default
	};
	
	if (!_pixi2.default.timerManager) {
	  _pixi2.default.timerManager = new _TimerManager2.default();
	
	  _pixi2.default.timer = timer;
	}
	
	exports.default = timer;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** build/pixi-timer.js
 **/